// ------------------------------------ consultant fetch ------------------------------------
import axios from 'axios'

export const EMPTY_CONSULTANT_NAME = 'EMPTY_CONSULTANT_NAME'
export const emptyConsultantName = () => ({
	type: EMPTY_CONSULTANT_NAME
})

export const CONSULTANT_REQUEST = 'CONSULTANT_REQUEST'
export const consultantRequest = () => ({
	type: CONSULTANT_REQUEST
})

export const CONSULTANT_RECEIVE = 'CONSULTANT_RECEIVE'
export const consultantReceive = consultant => ({
	type: CONSULTANT_RECEIVE,
	consultant
})

export const CONSULTANT_ERROR = 'CONSULTANT_ERROR'
export const consultantError = error => ({
	type: CONSULTANT_ERROR,
	error
})

export const consultantFetch = (
	counselingCenterUserName,
	consultantUserName,
	language,
	currency,
	timezone
) => {
	return dispatch => {
		dispatch(consultantRequest())

		axios.get(`https://panel.betterpro.app/api/consultant/${counselingCenterUserName}/${consultantUserName}`
			, {
				headers: {
					'X-Accept-Language': language,
					'X-Currency': currency,
					'X-Timezone': timezone
				}
			})
			.then(response => {
				dispatch(consultantReceive(response.data.content))
			})
			.catch(error => {
				dispatch(consultantError())
			})
	}
}


